import { render } from "./AnalyticsItem.vue?vue&type=template&id=298d9ac8"
import script from "./AnalyticsItem.vue?vue&type=script&lang=js"
export * from "./AnalyticsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__